import PropTypes from 'prop-types'
import {utils} from 'santa-components'

export default utils.createSantaTypesDefinitions({
    handleModesInOutBehaviors: PropTypes.func,
    handleModesTransitionBehaviors: PropTypes.func,
    compActiveMode: PropTypes.object,
    modeChildrenMeasures: PropTypes.object
}, 'ModesTransitionGroupHOC')
